<template lang="pug">
  div
    div(v-if="orders.length === 0")
      p {{ trans('labels.frontend.payment-confirmation.no_order') }}
    .payment-confirmation__box(v-if="orders.length > 0")
      .row
        .col-6
          .form-group.form-group--required
            label.control-label(for='order_id') {{ trans('labels.frontend.payment-confirmation.payment-confirmation-title') }}
            select#order_id.custom-select(name='order_id' v-model="form.order")
              option(value='' disabled="disabled") {{ trans('labels.frontend.payment-confirmation.choose_order') }}
              option(v-for="order in orders" :key="order.id" :value="order") {{ trans('labels.frontend.payment-confirmation.order_no') }} {{ order.number }} - {{ trans('labels.frontend.payment-confirmation.total') }} ฿ {{ order.net_total | numeral }}
        .col-6
          .form-group.form-group--required(v-bind:class="{ 'form-group--error':  $v.form.amount.$model && !isValueEqual }")
            label.control-label(for='amount') {{ trans('labels.frontend.payment-confirmation.amount') }}
            input#amount.form-control(type='number', name='amount', placeholder='0.00' v-model="form.amount" step=".01")
      .row
        .col-12
          .form-group.form-group--required
            label.control-label(for='bank') {{ trans('labels.frontend.payment-confirmation.transfer_to') }}
            .form-check.mb-2(v-for="bank in setting.bank_information" v-if="setting.bank_information")
              input.form-check-input(type='radio', name='bank_name', :value='bank' :id="'bank-' + bank.id" v-model='form.bank')
              label.form-check-label.d-flex.flex-row.align-items-center(:for="'bank-' + bank.id")
                .form-check-label__icon
                  font-awesome-icon(:icon=['far', 'check'])
                .row.align-items-center.w-100
                  .d-none.d-md-flex.w-100
                    div.col-lg-auto.col-auto.pt-4.pt-md-0.text-center
                      img.bank-logo(:src="'/img/frontend/logo/payment/' + bank.bank_name + '.png'", alt='', width='28', height='auto')
                    div.col-lg-4.col-md-4.col-4 {{ getBankName(bank.bank_name) }}
                    div.col-md-3.col-auto {{ bank.account_no }}
                    div.col-md-auto
                      span(v-if="!$store.getters['auth/user'].locale || $store.getters['auth/user'].locale === 'th'") {{ bank.account_name }}
                      span(v-if="$store.getters['auth/user'].locale && $store.getters['auth/user'].locale === 'en'") {{ bank.account_name_en }}
                  .d-flex.d-md-none.w-100.row.no-gutters.align-items-center
                    .col-auto.text-center
                      img.bank-logo.mt-0.mx-3(:src="'/img/frontend/logo/payment/' + bank.bank_name + '.png'", alt='')
                    .col
                      .row
                        .col
                          span.d-block {{ bank.account_no }}
                          small(v-if="!$store.getters['auth/user'].locale || $store.getters['auth/user'].locale === 'th'") {{ bank.account_name }}
                          small(v-if="$store.getters['auth/user'].locale && $store.getters['auth/user'].locale === 'en'") {{ bank.account_name_en }}
      .row
        .col-12
          .form-group.form-group--required
            label.control-label(for='date') {{ trans('labels.frontend.payment-confirmation.transfer_slip') }}
            .form-group.row
              .col-lg-6
                img.img-fluid(:src="form.confirmation_slip")
                vue-dropzone(ref="paymentSlipDropzone" id="dropzone" :options="dropzoneOptions" v-if="!form.confirmation_slip")
      .row
        .col-12
          button.btn.btn-primary.btn-lg(@click.prevent="onSubmit" :title="trans('labels.frontend.payment-confirmation.payment-confirmation-title')" :disabled="$v.$invalid || !isValueEqual") {{ trans('labels.frontend.payment-confirmation.payment-confirmation-title') }}
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import vue2Dropzone from 'vue2-dropzone';
import { Datetime } from 'vue-datetime';
import { RepositoryFactory } from '../../repositoryFactory';
import 'vue-datetime/dist/vue-datetime.css';
import notify from '../notify';
import router from '../../routes';

const OrderRepository = RepositoryFactory.get('order');
const SettingRepository = RepositoryFactory.get('setting');
const PaymentRepository = RepositoryFactory.get('payment');

const { moment } = window;

export default {
  components: {
    Datetime,
    vueDropzone: vue2Dropzone,
  },
  mixins: [validationMixin],
  data() {
    const vm = this;
    return {
      form: {
        order: '',
        amount: '',
        bank: null,
        datetime: '',
        confirmation_slip: '',
      },
      isValueEqual: false,
      orders: [],
      setting: {},
      dropzoneOptions: {
        url: '/api/payment/confirm/upload',
        uploadMultiple: false,
        thumbnailHeight: 128,
        thumbnailWidth: 128,
        maxFilesize: 10,
        filesizeBase: 4096,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        destroyDropzone: false,
        init() {
          this.on('removedfile', (file) => {
            if (vm.step !== 3) return;
            if (!_.isEmpty(file.xhr.response)) {
              const response = JSON.parse(file.xhr.response);
              if (!_.isEmpty(response.filename)) {
                const fileIndex = vm.form.files.indexOf(response.filename);
                if (fileIndex > -1) {
                  // vm.form.files.splice(fileIndex, 1);
                }
              }
            }
          });
          this.on('success', (file, data) => {
            this.removeFile(file);
            vm.form = { ...vm.form, ...{ confirmation_slip: data.data } };
          });
        },
        headers: {
          Accept: window.axios.defaults.headers.common.Accept,
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': window.axios.defaults.headers.common['X-CSRF-TOKEN'],
        },
      },
      options: {
        datetime: {
          max_datetime: moment().toISOString(),
        },
      },
    };
  },
  mounted() {
    this.getSettings();
    this.getOrders();
    this.$watch('form.amount', (val, oldVal) => {
      if (typeof val === "undefined" || this.form.order == '') return;
      if (val === oldVal) return;
      if (parseFloat(val) === parseFloat(this.form.order.net_total)) {
        this.isValueEqual = true;
      } else {
        this.isValueEqual = false;
      }
    });
  },
  methods: {
    async getSettings() {
      const { data } = await SettingRepository.get({ name: 'bank_information' });
      this.setting = data;
    },
    async getOrders() {
      const { data } = await OrderRepository.get({ paginated: false, status: 'pending_order' }).then((resp) => resp.data);
      this.orders = data;
    },
    getBankName(bank) {
      let name = '';
      switch (bank) {
        case 'kbank':
          name = Lang.get('labels.frontend.payment-confirmation.banks.kbank');
          break;
        case 'bbl':
          name = Lang.get('labels.frontend.payment-confirmation.banks.bbl');
          break;
        case 'scb':
          name = Lang.get('labels.frontend.payment-confirmation.banks.scb');
          break;
        case 'ktb':
          name = 'กรุงไทย';
          break;
        default:
          break;
      }
      return name;
    },
    async onSubmit() {
      try {
        const { data } = await PaymentRepository.confirm(this.form);
        router.push(`/account/orders/${data.other_details.order.number}`);
        notify.message(this, { title: Lang.get('alerts.general.operation_completed'), text: false }, 'success');
        this.getOrders();
      } catch (e) {
        notify.clean().then(() => notify.errors(this, e));
      }
    },
  },
  validations: {
    form: {
      order: { required },
      amount: { required },
      bank: { required },
      confirmation_slip: { required },
    },
  },
};
</script>
